import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "../locales/en-gb/translations.json";
import translationES from "../locales/es/translations.json";

// Get user language preference from session storage
const getUserLanguage = () => {
  try {
    const userDetails = JSON.parse(sessionStorage.getItem("loggedUserData"));
    return userDetails?.user_data?.language?.code?.replace("-", "_") ?? "en_gb";
  } catch (error) {
    return "en_gb";
  }
};

const lng = getUserLanguage();

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en_gb: {
        translation: translationEN,
      },
      es: {
        translation: translationES,
      },
    },
    fallbackLng: "en_gb",
    lng,
    keySeparator: ".",
    supportedLngs: ["en_gb", "es"],
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
